import React from 'react';
import { Composites, TextLabel, Thumbnails } from '@wix/wix-base-ui';
import { AlignLeft } from '../thumbnails/alignments/AlignLeft';
import { AlignCenter } from '../thumbnails/alignments/AlignCenter';
import { AlignRight } from '../thumbnails/alignments/AlignRight';

export enum Alignments {
  LEFT = 'left',
  RIGHT = 'right',
  CENTER = 'center',
}

export enum AlignmentDataHooks {
  Left = 'AlignmentDataHooks.Left',
  Center = 'AlignmentDataHooks.Center',
  Right = 'AlignmentDataHooks.Right',
}

const Alignment = ({
  label,
  value,
  onChange,
  labelDataHook,
}: {
  labelDataHook?: string;
  label: string;
  value: string;
  onChange: Function;
}) => {
  const alignmentThumbnails = [
    {
      value: Alignments.LEFT,
      dataHook: AlignmentDataHooks.Left,
      illustration: <AlignLeft />,
    },
    {
      value: Alignments.CENTER,
      dataHook: AlignmentDataHooks.Center,
      illustration: <AlignCenter />,
    },
    {
      value: Alignments.RIGHT,
      dataHook: AlignmentDataHooks.Right,
      illustration: <AlignRight />,
    },
  ];

  return (
    <Composites.Thumbnails>
      <TextLabel value={label} dataHook={labelDataHook} />
      <Thumbnails
        value={value}
        onChange={onChange}
        maxThumbsPerRow={5}
        options={alignmentThumbnails}
      />
    </Composites.Thumbnails>
  );
};

export default Alignment;
